<div class="floating-banner" *ngIf="showBanner">
    <p class="message" role="alert">{{message}}</p>
</div>
